export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGUOT = "LOGOUT";
export const STEP1 = "STEP1";
export const STEP2 = "STEP2";
export const EVENT_CREATED = "EVENT_CREATED";
export const PASSWORDRESET = "PASSWORDRESET";
export const PASSRESETERROR = "PASSRESETERROR";
export const PASSWORDSETERROR = "PASSWORDSETERROR";
export const PASSWORDCHANGED = "PASSWORDCHANGED";
export const SHOWSCHEDULE = "SHOWSCHEDULE";
